import PropTypes from 'prop-types';
import { Alert } from 'antd';
import { formatRefDate } from '../../utils/formatRefDate';

export default function DataGapDetail({ alert, duration }) {
    const facts = [
        ['Sensor', `${alert.SensorName} (${alert.PrimarySensorCode})`],
        ['Allowed interval', `${alert.GapMinutes} minutes`],
        ['Last data before gap', formatRefDate(alert.LastDataBeforeGap)],
        ['No data from', formatRefDate(alert.FirstOccurrenceDate)],
        ['Data returned at', alert.ClosedDate ? formatRefDate(alert.ClosedDate) : 'Not returned by evaluation time'],
        ['Evaluated until', formatRefDate(alert.EvaluatedUntil)],
        ['No-data duration', duration],
    ];
    return <section aria-label="Data gap timeline" className="space-y-4">
        <Alert type={alert.ClosedDate ? 'success' : 'warning'} showIcon
            message={alert.ClosedDate ? 'Sensor data returned' : 'No sensor data by the end of this evaluation'}
            description="Missing readings can indicate a sensor, power or upload interruption. The cause cannot be confirmed from history alone." />
        <dl className="grid grid-cols-2 gap-x-3 gap-y-3 text-sm">{facts.map(([label, value]) => <div key={label} className="contents">
            <dt className="text-slate-500">{label}</dt><dd className="text-slate-900 break-words">{value}</dd>
        </div>)}</dl>
        <p className="text-xs text-slate-500">{alert.StartUnknown ? '“No data from” is the start of the selected period because no earlier reading is available.' : '“No data from” is the last reading plus the allowed interval.'} It is a detection boundary, not a confirmed time of power failure. Status is evaluated at the selected period end or the database time, whichever is earlier.</p>
        {alert.StartUnknown && <Alert type="info" showIcon message="The exact start of this gap is unknown"
            description="No earlier reading is available. The displayed start is the selected period start; the gap may have begun earlier." />}
    </section>;
}

DataGapDetail.propTypes = { alert: PropTypes.object.isRequired, duration: PropTypes.string.isRequired };
